export async function ensureCompanyMasterId(
    company: { id?: number; master_id?: number } | undefined,
    loadFullCompany: (id: number) => Promise<{ master_id?: number } | undefined>
): Promise<number | undefined> {
    if (company?.master_id) {
        return company.master_id;
    }

    if (!company?.id) {
        return undefined;
    }

    const fullCompany = await loadFullCompany(company.id);
    return fullCompany?.master_id;
}
